export default __webpack_public_path__ + "static/hero_about-bc654c5378423d00ca2d3d1b49f68269.jpg";